import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { SubmissionPaymentsCard } from '@framework/frontoffice-submission/payments/SubmissionPaymentsCard.tsx';

export interface ISubmissionSentTabPaymentsProps {
  active: boolean | null | undefined;
  submission: RichiestaDTO | null | undefined;
}

export function SubmissionSentTabPayments(
  props: ISubmissionSentTabPaymentsProps,
) {
  const { active, submission } = props;

  if (!active) return null;

  return (
    <SubmissionPaymentsCard
      submissionId={submission?.id}
      handleNavigation={undefined}
      submission={submission}
      hideCard={true}
    />
  );
}
